import iconAhimsa from "@/assets/icon-ahimsa.png";
import iconLotus from "@/assets/icon-lotus.png";
import iconKalash from "@/assets/icon-kalash.png";
import iconDiya from "@/assets/icon-diya.png";
import iconDerasar from "@/assets/icon-derasar.png";
import iconNamaste from "@/assets/icon-namaste.png";
import mandala from "@/assets/mandala-hero.png";
import templeBanner from "@/assets/temple-banner.jpg";

export const jainArt = {
  ahimsa: iconAhimsa,
  lotus: iconLotus,
  kalash: iconKalash,
  diya: iconDiya,
  derasar: iconDerasar,
  namaste: iconNamaste,
  mandala,
  banner: templeBanner,
};

export type JainArtKey = keyof typeof jainArt;

export function JainIcon({
  name,
  className,
  alt,
}: {
  name: JainArtKey;
  className?: string;
  alt?: string;
}) {
  return (
    <img
      src={jainArt[name]}
      alt={alt ?? ""}
      aria-hidden={!alt}
      className={className}
      loading="lazy"
    />
  );
}
